"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shakeInputIfInvalid = void 0;
var AnimationConfig = require("./animationConfig.json");
var typestyle_1 = require("typestyle");
var shakeAnimation = (0, typestyle_1.keyframes)({
    'from, to': { transform: 'translate3d(0, 0, 0)' },
    '15%, 45%, 75%': { transform: 'translate3d(-3px, 0, 0)' },
    '30%, 60%, 90%': { transform: 'translate3d(3px, 0, 0)' },
});
var errorAppearActive = (0, typestyle_1.style)({
    opacity: 1,
    animation: shakeAnimation + " " + AnimationConfig.ERROR_SHAKE_MS + "ms linear 0s 1 normal",
});
function shakeInputIfInvalid(shouldShake, inputRef) {
    return function () {
        if (shouldShake && inputRef.current) {
            inputRef.current.classList.add(errorAppearActive);
            inputRef.current.focus();
            setTimeout(function (el) {
                if (el.current) {
                    el.current.classList.remove(errorAppearActive);
                }
            }, AnimationConfig.ERROR_SHAKE_MS, inputRef);
        }
    };
}
exports.shakeInputIfInvalid = shakeInputIfInvalid;
//# sourceMappingURL=shakeInputIfInvalid.js.map